import React from "react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { chartColors, useChartTheme } from "./ChartTheme";
import DashboardCard from "./DashboardCard";
import CustomNoData from "../../../components/CustomNoData";

const UserActivityChart = ({ data = [], conversion = 0 }) => {
  const chartTheme = useChartTheme();

  return (
    <DashboardCard className="p-3">
      <header className="mb-2 flex items-center justify-between">
        <h2 className="text-base font-bold text-customInk dark:text-customHeading">Daily User Activity</h2>
        {/* <p className="text-xs text-customPrimaryText dark:text-customMuted">
          Conversion <span className="ml-2 text-lg font-bold text-customAccentBlue">{conversion.toFixed(1)}%</span>
        </p> */}
      </header>
      <div className="h-[228px]">
        {data.length === 0 ? (
          <CustomNoData title="No user activity" description="No user activity data found for the selected date range." />
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 8, right: 8, bottom: 0, left: -18 }}>
              <CartesianGrid stroke={chartTheme.grid} strokeDasharray="3 3" />
              <XAxis dataKey="date" tick={{ fill: chartTheme.axis, fontSize: 11 }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fill: chartTheme.axis, fontSize: 11 }} axisLine={false} tickLine={false} />
              <Tooltip contentStyle={{ background: chartTheme.tooltipBackground, borderColor: chartTheme.grid, color: chartTheme.tooltipText }} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              {/* <Line type="monotone" dataKey="active" name="Active Users" stroke={chartColors.ink} strokeWidth={2} dot={{ r: 3, fill: chartColors.ink }} /> */}
              <Line type="monotone" dataKey="betting" name="Betting Users" stroke={chartColors.sky} strokeWidth={2} dot={{ r: 3, fill: chartColors.sky }} />
            </LineChart>
          </ResponsiveContainer>
        )}
      </div>
    </DashboardCard>
  );
};

export default UserActivityChart;
